module.exports = __webpack_public_path__ + "static/media/google.6bbef719.png";